import API from "../../API";
import Description from "../../components/QrComponents/Description";

export const saveTrackerSurveyData = ({ id: qrId, data: updatedTrackerData, qrTypeParent }) => async () => {
    try {
        const date = new Date();
        const dataToSave = {
            [qrTypeParent]: updatedTrackerData,
            updated_at: date,
        };

        await API.updateQR(qrId, { qrDataType: qrTypeParent, files: [], data: dataToSave});
    } catch (error) {
        console.error('Failed to save tracker data:', error);
    };
};

export const saveCategoryData = (qrId, updatedCategoryData) => async () => {
    try {
        const date = new Date();
        const dataToSave = {
            updated_at: date,
            category: updatedCategoryData,
        };

        await API.updateQR(qrId, { qrDataType: "", files: [], data: dataToSave});
    } catch (error) {
        console.error('Failed to save category data:', error);
    };
};

export const saveTagData = (qrId, updatedTagData) => async () => {
    try {
        const date = new Date();
        const dataToSave = {
            updated_at: date,
            tags: updatedTagData,
        };
        await API.updateQR(qrId, {qrDataType: "", files: [], data: dataToSave});
    } catch (error) {
        console.error('Failed to save tag data:', error);
    };
};

const _saveNicknameData = async (qrId, updatedNicknameData) => {

    try {
        const date = new Date();
        const dataToSave = {
          qrDataType: '',
          files: [],
          data: {
            updated_at: date,
            nickname: updatedNicknameData,
          },
        };

        await API.updateQR(qrId, {qrDataType: "", files: [], data: dataToSave});
    } catch (error) {
        console.error('Failed to save nickname data:', error);
    };
};

const _saveDescriptionData = async (qrId, updatedDescriptionData) => {

    try {
        const date = new Date();
        const dataToSave = {
            updated_at: date,
            description: updatedDescriptionData,
        };

        await API.updateQR(qrId, { qrDataType: '', files: [], data: dataToSave });
    } catch (error) {
        console.error('Failed to save description data:', error);
    };
};

let timeoutId;
const debounce = (func, delay) => {
    return function(...args) {
        const context = this;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(context, args), delay);
    };
};

export const saveNicknameData = debounce(_saveNicknameData, 500);
export const saveDescriptionData = debounce(_saveDescriptionData, 500);

// One-time normalization: resolve legacy field type IDs to canonical unified IDs
// Normalize legacy tracker/survey schema (questions/columns -> fields) and optionally field type IDs
export const normalizeFieldTypes = async ({ qrId, qrData }) => {
    try {
        if (!qrId || !qrData?.data) return { normalized: false, reason: 'missing data' };

        const dataCopy = { ...qrData.data };
        let changed = false;

        const normalizeGroup = (groupKey, legacyKey) => {
            const group = dataCopy[groupKey];
            if (!group) return;
            const legacyArray = group.fields || group[legacyKey];
            if (!legacyArray) return;
            // If fields missing but legacy present, migrate
            if (!group.fields && group[legacyKey]) {
                group.fields = [...group[legacyKey]];
                delete group[legacyKey];
                changed = true;
            }
            // Remove legacy key if still lingering
            if (group[legacyKey]) {
                delete group[legacyKey];
                changed = true;
            }
        };

        normalizeGroup('tracker', 'columns');
        normalizeGroup('survey', 'questions');

        if (!changed) return { normalized: false, reason: 'already normalized' };

        const date = new Date();
        const payload = {
            updated_at: date,
            tracker: dataCopy.tracker,
            survey: dataCopy.survey,
            fields_normalized: true,
        };

        await API.updateQR(qrId, { qrDataType: '', files: [], data: payload });
        return { normalized: true, trackerCount: dataCopy.tracker?.fields?.length || 0, surveyCount: dataCopy.survey?.fields?.length || 0 };
    } catch (error) {
        console.error('Failed to normalize field schema:', error);
        return { normalized: false, error };
    }
};